document.addEventListener("DOMContentLoaded", function() {
  const results = document.querySelector('.results');

  if (results) {
    const statistics = document.querySelectorAll('.resultsCard__body-number');

    statistics.forEach(function(statistic) {
      var count = statistic;
      var zero = { val: 0 };
      var num = parseFloat(count.getAttribute('data-number').replace(/,/g, '')); // Remove commas
      var split = (num + '').split('.'); // To cover for instances of decimals
      var decimals = split.length > 1 ? split[1].length : 0;

      gsap.to(zero, {
        val: num,
        duration: 3,
        scrollTrigger: statistic,
        onUpdate: function() {
          count.textContent = formatNumberWithCommas(zero.val.toFixed(decimals));
        }
      });
    });

  }

  function formatNumberWithCommas(number) {
    var parts = number.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
});
